<template>
  <zen-one :showuserinfo="false" title="" :crumbs="crumbs">
     <z-page :title="title">
      <w-form class="" v-model="form.valid" v-model:errors-count="form.errorsCount" @validate="onValidate" @success="onSuccess()" >
        <div class="w-flex wrap smd-column" >
          <div class="grow " >
            <w-input class="mt4" label="Tarikh *" type="date" v-model="form.tarikh" :validators="[validators.required]"/>
            <z-select class="mt4" :items="no_tangki"  label="No Tangki *"  v-model="form.tangki_id" :validators="[validators.required]"/>
            <w-input class="mt4" label="Sebelum (cm)" type="text" v-model="form.seebelum" :validators="[validators.required]"/>
            <w-input class="mt4" label="Selepas (cm)" type="text" v-model="form.selepas" :validators="[validators.required]"/>
            <w-input class="mt4" label="Isipadu Topup (L)" type="text" v-model="form.isipadu_topup_l" :validators="[validators.required]"/>
            <w-input class="mt4" label="Isipadu Topup (m³)" type="text" v-model="form.isipadu_topup_m" :validators="[validators.required]" readonly/>

          </div>
        </div>
        <w-flex class="mt3" wrap align-center justify-end v-if="$zutil.anyRole(['1', '3'])">
           <w-button class="my1"   :loading="form.submitted && !form.sent" @click="send(2); onSuccess()">
                <w-icon dark tile class="mr2">fal fa-save</w-icon> SIMPAN
                    </w-button>
                  &nbsp;
                    <w-button class="my1" bg-color="success" type="submit" :disabled="form.valid === false" :loading="form.submitted && !form.sent" @click="send(1)">
              <w-icon xs class="mr2">fal fa-paper-plane</w-icon> HANTAR
            </w-button>
        </w-flex>
        <div class="mt2 text-left">
          <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 11px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="tutup">TUTUP</w-button>&nbsp;
        </div>
      </w-form>
     </z-page>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'



export default {
  extends: ZResource,
  props: {
    d_form: [Array, Object],
    d_no_tangki :[Array, Object],

    
  },
  data() {
    return {
      resourceurl: 'tangki.selenggara',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Pengurusan Cecair Nitrogen', route: '/tangki' },
        { label: 'Selenggara Tangki', route: '/tangki/selenggara' },
      ],
      title : 'Selenggara Tangki',
      form : this.d_form,
      no_tangki : this.d_no_tangki,
      
    }
  },
  methods: {
    send(hantar){
      this.form.hantar = hantar
    },
    onSuccess(){
      if(this.form.hantar == 1){
        this.$swal({
            title: 'Anda Pasti?',
            // text: "Are you sure want to delete this item!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ya',
            cancelButtonText: 'Tidak'
          }).then((result) => {
            if (result.value) {
              if (this.form.id > 0){
                this.$zcomm.update(this.resourceurl + '.update', this.form.id, this.form)
                .then(res => {
                  if (typeof this.onAfterEdit === "function") {
                    this.onAfterEdit()
                  }
                  if (this.form.hantar==1) {
                      this.$inertia.visit(this.$route('tangki.selenggara.show', this.form.id));
                  }else{
                      this.$zutil.notify("Berjaya disimpan", true);
                  }
                  // this.$inertia.visit(this.$route('se.pemungutan.show', this.form.id))
                })
              }else{
                this.$zcomm.post(this.resourceurl+'.store' , this.form)
                .then(res => {
                  if (typeof this.onAfterAdd === "function") {
                    this.onAfterAdd()
                  }
                  this.$zutil.notify("Berjaya dihantar", true);
                  this.$inertia.visit(window.route('tangki.selenggara.show',res.id));

                })
              }
            }
          })
      }else{
        if (this.form.id > 0) 
        {
          
          this.$zcomm.update(this.resourceurl + '.update', this.form.id, this.form)
          .then(res => {
            if (typeof this.onAfterEdit === "function") {
              this.onAfterEdit()
            }
            if (this.form.hantar==1) {
                this.$inertia.visit(this.$route('tangki.selenggara.show', this.form.id));
            }else{
                this.$zutil.notify("Berjaya disimpan", true);
                this.$inertia.visit(this.$route('tangki.selenggara.form', this.form.id));
            }
            // this.$inertia.visit(this.$route('se.pemungutan.show', this.form.id))
          })
        }
        else 
        {
          this.$zcomm.post(this.resourceurl+'.store' , this.form)
          .then(res => {
            if (typeof this.onAfterAdd === "function") {
              this.onAfterAdd()
            }
            this.$zutil.notify("Berjaya disimpan", true);
            this.$inertia.visit(this.$route('tangki.selenggara.form', res.id));
            // this.$inertia.visit(this.$route('se.pemungutan.show', res.id))

          })
        }
      } 
      
    },

    
    


  
   tutup(){
         this.$inertia.visit(window.route('tangki.selenggara.index'));
       },
    



    
  },

  watch: {
    'form.isipadu_topup_l'(val) {
      // Tukar nilai L ke m³ (1 L = 0.001 m³)
      const liter = parseFloat(val)
      this.form.isipadu_topup_m = !isNaN(liter) ? (liter * 0.001).toFixed(3) : ''
    }
  },
  mounted() {
    if(this.form.id > 0)
    {
      this.title = 'Kemaskini Selenggara Tangki LN2'
    }
    else
    {
      this.title = 'Tambah Selenggara Tangki LN2'
    }
   
    
  }

    
}
</script>
